import { configureStore } from "@reduxjs/toolkit";
import productDetailsReducer from "../features/product_details/productDetailsSlice"
import categoryWiseProductReducer from "../features/categories/categoryWiseProductSlice";
import menusDataReducer from "../features/menus/menusSlice";
import generalSettingsDataReducer from "../features/settings/generalSettingsSlice";
import mainSliderDataReducer from "../features/sliders/mainSliderSlice";
import featuredCategoryDataReducer from "../features/categories/featuredCategorySlice";
import flashDealsProductsData from "../features/products/flashDealsSlice";
import topPicksProductsDataReducer from "../features/products/topPicksSlice";
import featuredBrandsDataReducer from "../features/brands/featuredBrandsSlice";
import fetchCartReducer from "../features/cart/cartSlice";
import bestSellingProductsDataReducer from "../features/products/bestSellingSlice";

export const store = configureStore({
    reducer: {
        generalSettings: generalSettingsDataReducer,
        menus: menusDataReducer,
        mainSlider: mainSliderDataReducer,
        featuredCategory: featuredCategoryDataReducer,
        category_details: categoryWiseProductReducer,
        flashDealsproducts: flashDealsProductsData,
        topPicksproducts: topPicksProductsDataReducer,
        bestSellingProducts: bestSellingProductsDataReducer,
        product_details: productDetailsReducer,
        featuredBrands: featuredBrandsDataReducer,
        cartProductList: fetchCartReducer,

    }
})